<template>
  <va-edit-layout>
    <OrderRequestItem-form :id="id" :title="title" :item="item"></OrderRequestItem-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
